import ACL_Service from 'Services/ACL_Service'
import WeaverService from 'Services/WeaverService'
import { WeaverQuery, getProjectData } from 'Services/WeaverUtils'

class PermissionsService

  isEditable: (key, isRelation)->
    return false if !WeaverService.userCanEdit()
    permissions = (getProjectData().permissions or [])
      .filter((rule) ->
        rule.rel_key? is isRelation
      ).filter((rule) ->
        if isRelation
          rule.rel_key is key
        else
          rule.attr_key is key
      )

    isEditable = !permissions[0]?

    permissions.find(({ write, function_access }) ->
      if write
        function_access.map((acl) ->
          if ACL_Service.hasAclAccess(acl)
            isEditable = true
        )
    )
    isEditable

  getRelationTargetQuery: (key) ->
    restrictedTargets = @getRelationPermittedTargets(key)

    if restrictedTargets?
      WeaverQuery().restrict(restrictedTargets)
    else
      WeaverQuery()

  getRelationPermittedTargets: (key) ->
    if key
      permissions = (getProjectData().permissions or [])
        .filter(({ rel_key }) -> rel_key is key)

      return undefined if permissions.length is 0

      unless permissions.find((rule) -> rule.permitted_targets) # Some rule does not restrict targets
        undefined
      else # All rules restrict at least some targets
        permissions.map((rule) -> rule.permitted_targets)
          .flat()

  filterPermittedTargets: (key, arr, selected) ->
    permitted = @getRelationPermittedTargets(key)

    if permitted
      arr.filter((i) -> permitted.indexOf(i) isnt -1).concat(selected)
    else
      arr

export default new PermissionsService()
